<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="profiles"
      :server-items-length="totalProfiles"
      :loading="loading"
      :page="page"
      :options.sync="options"
      :sort-by.sync="sortBy"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="loadTable" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.profiles.name')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.name"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg" elevation="1" color="#41916b" @click="dialog = true, resource = {}">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="dialog = true, resource = item">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="loadTable()"
            url="profiles"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog" width="400px">
      <v-card-title>
        <span>{{ resource.id ? $t('titles.edit_profile') : $t('titles.new_profile') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="saveProfile">
          <v-text-field v-model="resource.name" :label="$t('inputs.profiles.name')" color="#41916b" />
          <v-text-field v-model="resource.slug" :label="$t('inputs.profiles.slug')" color="#41916b" />
          <v-btn color="#41916b" class="rounded-lg" type="submit" dark style="margin-right: 10px;" :loading="loading">
            {{$t('buttons.save')}}
          </v-btn>
          <v-btn color="white" class="rounded-lg" @click="dialog = false, resource = {}">
            {{$t('buttons.cancel')}}
          </v-btn>
        </v-form>
      </v-card-text>
    </Modal>
  </div>
</template>

<script>
import { getProfiles, saveProfile } from "@/service/basic-registrations/ProfileService";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Menu,
    ChangeStatus,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      filterForm: {},
      headers: [
        { text: "Perfil", align: "start", value: "name" },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 1,
      loading: false,
      options: {},
      sortBy: "name",
      profiles: [],
      resource: {},
      totalProfiles: 0,
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "UsuarioForm",
        },
        {
          name: "Permissões",
          type: "page",
          route: "/listar-permissoes",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "UsuarioForm",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.changeActionsData(this.actions);
    this.loadTable();
  },

  watch: {
    options: {
      handler() {
        this.loadTable();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changeActionsData"]),

    loadTable() {
      const { page, itemsPerPage } = this.options;
      this.loading = true;
      getProfiles({
        name: this.filterForm.name || '',
        page,
        per_page: itemsPerPage,
      }).then((result) => {
        this.profiles = result.data;
        this.totalProfiles = result.total;
        this.loading = false;
      });
    },

    clearFilter() {
      this.filterForm = {};
      this.loadTable();
    },

    saveProfile() {
      this.loading = true;
      const profile = {
        name: this.resource.name.toUpperCase(),
        slug: this.resource.slug.toUpperCase(),
      };

      saveProfile(this.resource.id || null, profile).then((response) => {
        this.changeSnackBarData({
          status: true,
          type: "success",
          titleMessage: response.data.message,
          bodyMessage: "",
          cardColor: "#41916b",
          titleIcon: "mdi-checkbox-marked-circle",
        });
        this.loading = false;
        this.dialog = false;

        setTimeout(() => {
          if (!this.resource.id) {
            this.$router.push({ path: '/listar-permissoes', query: { item: response.data.id } });
          } else {
            this.loadTable();
            this.resource = {};
          }
          this.changeSnackBarData({ status: false, type: '', titleMessage: '', bodyMessage: '', cardColor: '', titleIcon: '' });
        }, 2000);
      }).catch((err) => {
        this.loading = false;
        this.changeSnackBarData({
          status: true,
          type: "error",
          titleMessage: err.response.data.message,
          bodyMessage: "",
          cardColor: "#41916b",
          titleIcon: "mdi-alert-circle",
        });
        setTimeout(() => {
          this.dialog = false;
          this.changeSnackBarData({ status: false, type: '', titleMessage: '', bodyMessage: '', cardColor: '', titleIcon: '' });
        }, 3000);
      });
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
